// Account JS
function openPopup(){
  $('body').addClass('popupactive');
  $('.account-popup').fadeIn('slow');
  $('.overlay').addClass('active');
}
function closePopup(){
  $('body').removeClass('popupactive');
  $('.account-popup').fadeOut('slow');
  $('.overlay').removeClass('active');
}

function openCart(){
  $('body').addClass('minicartOpen');
  $('#crt').slideDown();
  $('#crt').addClass('open_drawer');
 }
function closeCart(){
  $('body').removeClass('minicartOpen');
  $('#crt').slideUp();
  $('#crt').removeClass('open_drawer');
  $('.popoverlay').removeClass('active');
}
function addToCartSuccess() {
  $.get( "/cart?view=mini", function( data ) {
    $('#crt').html(data);
    $('#crt').removeClass('loading');
  });
}
function refreshCart(cart) {
  $('span#minicartCount').text(cart.item_count);
}
function delete_cookie(name) {
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
$(function() {
  $('.step__footer__continue-btn').on('click', function() {
    //delete_cookie('cart');
    $.getJSON('/cart.js', function(cart){
      refreshCart(cart);
    });
  });
  if ($('.template-index').length > 0) {
    $.getJSON('/cart.js', function(cart){
      refreshCart(cart);
    });
  }
});
console.log('Hello from confitex-two'); 
$(function(){
  console.log('READY!!!!');
  //show spinning 3d image when hovered slide has spinner
  $(".qv_main").on("mouseover", function(e){
    if($(".qv_main .slick-active").find(".3d-front-image").length > 0) {
      showSpinner();
    }
  });

  //auto show spinning 3d image on mobile
  if($(window).width() <= 991) {
    showSpinner();
  }
  $(window).resize(
    $.debounce(50, function() {
      if($(window).width() <= 991) {
        showSpinner();
      }
    })
  );
  //rehide spinner when slide is not active, for tablet and desktop
  $('.qv_main').on('afterChange', function(event, slick, currentSlide, nextSlide){
    if($(this).find(".slick-active .3d-front-image").length <= 0 && $(window).width() > 991) {
      $(this).find(".3d-front-image").show();
      $(this).find("#-spin-studio-large-thumb-reel").addClass("hidden");
      $(this).find("#-spin-studio-large-thumb").addClass("hidden");
    } else if($(window).width() <= 991) {
      showSpinner();
    }
  });

  function showSpinner() {
    $(".qv_main .slick-active .3d-front-image").hide();
    $(".qv_main .slick-active #-spin-studio-large-thumb-reel").removeClass("hidden");
    $(".qv_main .slick-active #-spin-studio-large-thumb").removeClass("hidden");
  }

  $('body').on('click','.site-header__icons-wrapper .con-header-account',function(e){
    e.preventDefault();
    closeCart();
    openPopup();
  });

  $('body').on('click','.site-header__icons-wrapper .close_btn > span',function(e){
    e.preventDefault();
    closePopup();
  });
  $(document).keyup(function(e) {
    if (e.keyCode == 27) { 
      closePopup();
      closeCart();
    }
  });
  window.onclick = function(e) {
    if (jQuery(e.target).hasClass('popoverlay') || jQuery(e.target).hasClass('overlay')) {
      closeCart();
      closePopup();
    }  
  }

  $('.site-header__cart .cs-mini-cart').on('click',function(e){
    e.preventDefault();
    closePopup();
    openCart();
    e.stopPropagation();
  });

  $('body').on('click','.clsoe_btn',function(e){
    e.preventDefault();
    closeCart();
    e.stopPropagation();
  });

  $(document).on('click', function (e) {
    if ($(e.target).is("#crt, #crt *") === false) {
      closeCart();
    }
  });
  $('body').on('click','.product-form__cart-submit',function(e){
    e.preventDefault();
    var btn = $(this);
    var form = $(this).closest('form');
    btn.attr('disabled', 'disabled');
    btn.text('adding...');
    form.find('.error').remove();

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
        btn.text('add to cart');
        btn.removeAttr('disabled');
      }
    }).done(function( data ) {
      addToCartSuccess();
      btn.text('add to cart');
      btn.removeAttr('disabled');
      $.getJSON('/cart.js', function(cart){
        refreshCart(cart);
      });
      $('html, body').animate({scrollTop:0}, '300');
      openCart();
    });
  });
  $('body').on('click','#AddToCart-product-recommendations',function(e){
    e.preventDefault();
    var btn = $(this);
    var form = $(this).closest('form');
    btn.attr('disabled', 'disabled');
    btn.text('adding...');
    form.find('.error').remove();

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
        btn.text('add to cart');
        btn.removeAttr('disabled');
      }
    }).done(function( data ) {
      addToCartSuccess();
      btn.text('add to cart');
      btn.removeAttr('disabled');
      $.getJSON('/cart.js', function(cart){
        refreshCart(cart);
      });
      $('html, body').animate({scrollTop:0}, '300');
      openCart();
    });
  });
  $("#crt").on('click', "a.remove_item", function(r){
    $('#crt').addClass('loading');
    r.preventDefault();
    var id = $(this).data("id");
    Shopify.changeItem(id,0, function(c){
      $('.itemCount').text(c.item_count);
      if(!c.item_count) {
        $('#crt .mini-cart').empty();
        $('#crt .mini-cart').append('<p class="emptyCart text-center">You have no items in your bag.</p>');
        $('#crt').removeClass('has-item');
        $('#crt').removeClass('loading');
        $.getJSON("/cart.js", function(cart) {
          refreshCart(cart);
        });
      } else {
        addToCartSuccess();
      }
    });
    $.getJSON("/cart.js", function(cart) {
      refreshCart(cart);
    });
  });
  $('.help .size-table').hide();
  $('.btn-metric.men').addClass('active-btn');
  $('.btn-imperial.men').removeClass('active-btn');
  $('.help .btn-metric.men').click(function(e){
    e.preventDefault();
    $('.help .help-imperial.men').hide();
    $('.help .help-metric.men').show();
    $('.help .btn-metric.men').addClass('active-btn').siblings('.size-guide-btn').removeClass('active-btn');
  });
  $('.help .btn-imperial.men').click(function(e){
    e.preventDefault();
    $('.help .help-imperial.men').show();
    $('.help .help-metric.men').hide();
    $('.help .btn-imperial.men').addClass('active-btn').siblings('.size-guide-btn').removeClass('active-btn');
  });
  
  $('.btn-metric.women').addClass('active-btn');
  $('.btn-imperial.women').removeClass('active-btn');
  
  $('.help .btn-metric.women').click(function(e){
    e.preventDefault();
    $('.help .help-imperial.women').hide();
    $('.help .help-metric.women').show();
    $('.help .btn-metric.women').addClass('active-btn').siblings('.size-guide-btn').removeClass('active-btn');
  });
  $('.help .btn-imperial.women').click(function(e){
    e.preventDefault();
    $('.help .help-imperial.women').show();
    $('.help .help-metric.women').hide();
    $('.help .btn-imperial.women').addClass('active-btn').siblings('.size-guide-btn').removeClass('active-btn');
  });
  
  $('.help .active-btn').trigger('click');

  if($('.blog-header-slider .bnr-slider').length > 1){
    $('.blog-header-slider').slick({
      dots: true,
      arrows: false,
      swipeToSlide: true,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear',
      autoplay: true,
      autoplaySpeed: 4000
    });
  }
    
  $('.faqs a[href*="#"]').on('click', function (e) {   
    e.preventDefault();
    var scrollTo = $(this).attr('href');
    $('html, body').animate({
      scrollTop: $(scrollTo).offset().top-30
    }, 500);
  });

  // $('.why-us a[href*="#"]').on('click', function (e) {   
  //   //e.preventDefault();
  //   var scrollTo = $(this).attr('href');
  //   $('html, body').animate({
  //     scrollTop: $(scrollTo).offset().top - 90
  //   }, 1000);
  // });

  if($(".cr-faq-item").length <= 6){
    $("#loadMore").hide();
  }
  $(".faqs .cr-faq-item").slice(0, 6).show();
  $("#loadMore").on("click", function(e){
    e.preventDefault();
    $(".cr-faq-item:hidden").slice(0, 2).slideDown();
    if($(".cr-faq-item:hidden").length == 0) {
      $("#loadMore").hide();
    }
  });
  $('.prod_tab_content .size-table').hide();
  $('.prod_tab_content .btn-metric').click(function(e){
    e.preventDefault();
    $('.prod_tab_content .help-imperial').hide();
    $('.prod_tab_content .help-metric').show();
    $('.prod_tab_content .btn-metric').addClass('active-btn').siblings('.size-guide-btn').removeClass('active-btn');
  });
  $('.prod_tab_content .btn-imperial').click(function(e){
    e.preventDefault();
    $('.prod_tab_content .help-imperial').show();
    $('.prod_tab_content .help-metric').hide();
    $('.prod_tab_content .btn-imperial').addClass('active-btn').siblings('.size-guide-btn').removeClass('active-btn');
  });
  $('.prod_tab_content .active-btn').trigger('click');

  $('.template-product .product-form__item .size_content').on('click', function(e){
    debugger;
    e.preventDefault();
    let offset = $(window).width() < 992 ? 50 : 73;
    if($(window).width() < 1600 && $(window).width() > 1204) {
      offset = 250;
    }
    $('.shogun-tab-content').removeClass('shogun-tab-active');
    var f = $('.shogun-tabs').offset().top - offset;
    $('html, body').animate({ scrollTop: f }, 500);
    $('.prod_tab_content .shogun-tabs').find('li').removeClass('shogun-tab-active');
    $('.prod_tab_content div.shogun-tab-content').removeClass('shogun-tab-active'); 
    //toggle tab
    $(".prod_tab_content li.shogun-tab:eq(4)").addClass('shogun-tab-active');
    $(".prod_tab_content div.shogun-tab-content:eq(4)").addClass('shogun-tab-active');

    $(".prod_tab_content .shogun-tabs").children().each(function() {
      if ($(this).hasClass("shogun-tab-active")) {
        $(this).removeClass("shogun-tab-off");
      } else {
        $(this).addClass("shogun-tab-off");
      }
    });
  });
  $('#size-guide').on('click', function(e){
    e.preventDefault();
    let offset = $(window).width() < 992 ? 100 : 73;
    if($(window).width() < 1600 && $(window).width() > 1204) {
      offset = 250;
    }
    $('.shogun-tab-content').removeClass('shogun-tab-active');
    var tabIndex = findTabToOpen($(this)) >= 0 ? findTabToOpen($(this)) : 1;
    var f = $(".prod_tab_content li.shogun-tab:eq("+tabIndex+")").offset().top - offset;
    $('html, body').animate({ scrollTop: f }, 500);
    $('.prod_tab_content .shogun-tabs').find('li').removeClass('shogun-tab-active');
    $('.prod_tab_content div.shogun-tab-content').removeClass('shogun-tab-active'); 
    //toggle tab
    $(".prod_tab_content li.shogun-tab:eq("+tabIndex+")").addClass('shogun-tab-active');
    $(".prod_tab_content div.shogun-tab-content:eq("+tabIndex+")").addClass('shogun-tab-active');

    $(".prod_tab_content .shogun-tabs").children().each(function() {
      if ($(this).hasClass("shogun-tab-active")) {
        $(this).removeClass("shogun-tab-off");
      } else {
        $(this).addClass("shogun-tab-off");
      }
    });
  });
  $(".product_desc_see_more").on('click', function(e) {
    e.preventDefault();
    let offset = $(window).width() < 992 ? 80 : 73;
    if($(window).width() < 1600 && $(window).width() > 1204) {
      offset = 250;
    }
    var f = $('.shogun-tabs').offset().top - offset;
    $('html, body').animate({ scrollTop: f }, 500);
    $('.prod_tab_content .shogun-tabs').find('li').removeClass('shogun-tab-active'); 
    $('.prod_tab_content div.shogun-tab-content').removeClass('shogun-tab-active');
    //toggle tab
    $(".prod_tab_content li.shogun-tab:eq(0)").addClass('shogun-tab-active');
    $(".prod_tab_content div.shogun-tab-content:eq(0)").addClass('shogun-tab-active');

    $(".prod_tab_content .shogun-tabs").children().each(function() {
      if ($(this).hasClass("shogun-tab-active")) {
        $(this).removeClass("shogun-tab-off");
      } else {
        $(this).addClass("shogun-tab-off");
      }
    });
  });

  $(".prod_tab_content .shogun-tabs").children().each(function() {
    if ($(this).hasClass("shogun-tab-active")) {

    } else {
      $(this).addClass("shogun-tab-off");
    }
  });

  $(".prod_tab_content .shogun-tabs .shogun-tab").off().on("click", function() {
    var $this = $(this);
    $this.siblings(".shogun-tab").removeClass("shogun-tab-active");
    $this.next().siblings(".shogun-tab-content").removeClass("shogun-tab-active");
    $this.next().toggleClass("shogun-tab-active");
    if($this.hasClass("shogun-tab-active")) { //shogun-tab-active is toggled by shogun script
      $this.toggleClass("shogun-tab-active").addClass("shogun-tab-off");
    }
  });
  if($('.artical-main-img .banner-image .img-wrapper').length > 1){
    $('.artical-main-img .banner-image').slick({
      dots: true,
      arrows: false,
      swipeToSlide: true,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear',
      autoplay: true,
      autoplaySpeed: 4000
    });
  }
  let $el = $('.mobile-image .qv_main');
  $('.mobile-image .qv_main').slick({
    dots: false,
    arrows: true,
    swipeToSlide: true,
    infinite: true,
    speed: 500,
    cssEase: 'linear',
    autoplay: true,
    autoplaySpeed: 4000,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          vertical: false,
          verticalSwiping: false,
          arrows: true,
          autoplay: true,
          speed: 500,
          useTransform: true,
          cssEase: 'ease-out',
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true, 
          centerMode: true,
          centerPadding: '0',
  		 
        }
      }
    ]
  });
  
  // Fix the product page's vertical slide. Make sure the slides have same heights.
  setCorrectProdImageHeight();
  $(window).resize(
    $.debounce(100, function() {
      setCorrectProdImageHeight();
    })
  );
  function setCorrectProdImageHeight() {
    if ($(window).width() > 991) {
      let maxHeight = -1;
      $('.mobile-image .qv_main .slick-slide').each(function() {
          if ($(this).height() > maxHeight) {
              maxHeight = $(this).height();
          }
      });
      $('.mobile-image .qv_main .slick-slide').each(function() {
          if ($(this).height() < maxHeight) {
              $(this).css('margin', Math.ceil((maxHeight-$(this).height())/2) + 'px 0');
          }
      });
    }
  }
});

$('#CustomerLoginForm form').on('submit',function(){
  var x = true;
  $(this).find('.err-msg').remove();
  var em = $(this).find('#CustomerEmail');
  var ps = $(this).find('#CustomerPassword');

  if(ps.val().trim() == ''){
    ps.css('border-bottom','1px solid red');
    ps.parent().append('<p class="err-msg">Please enter password.</p>');
    x = false;
  } else {
    ps.css('border-bottom','1px solid #000');
    ps.parent().find('.err-msg').remove();
  }

  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  if(em.val().trim() == '' || !regex.test(em.val())) {
    em.css('border-bottom','1px solid red');
    em.parent().append('<p class="err-msg">Please enter valid e-mail.</p>');
    x = false;
  } else {
    em.css('border-bottom','1px solid inherit');
    em.parent().find('.err-msg').remove();
  }
  if(x==false) {
    return false;
  }

});

$('#RecoverPasswordForm form').on('submit',function(){
  var x = true;
  $(this).find('.err-msg').remove();
  var em = $(this).find('#RecoverEmail');

  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  if(em.val().trim() == '' || !regex.test(em.val())) {
    em.css('border-bottom','1px solid red');
    em.parent().append('<p class="err-msg">Please enter valid e-mail.</p>');
    x = false;
  } else {
    em.css('border-bottom','1px solid inherit');
    em.parent().find('.err-msg').remove();
  }
  if(x==false) {
    return false;
  }

});

$('#registerForm form').on('submit',function(){
  var x = true;
  $(this).find('.err-msg').remove();
  var fn = $(this).find('#FirstName');
  var em = $(this).find('#Email');
  var ln = $(this).find('#LastName');
  var ps = $(this).find('#Password');

  if(fn.val().trim() == ''){
    fn.css('border-bottom','1px solid red');
    fn.parent().append('<p class="err-msg">Please enter first name.</p>');
    x = false;
  } else {
    fn.css('border-bottom','1px solid inherit');
    fn.parent().find('.err-msg').remove();
  }

  if(ln.val().trim() == ''){
    ln.css('border-bottom','1px solid red');
    ln.parent().append('<p class="err-msg">Please enter last name.</p>');
    x = false;
  } else {
    ln.css('border-bottom','1px solid inherit');
    ln.parent().find('.err-msg').remove();
  }
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  if(em.val().trim() == '' || !regex.test(em.val())) {
    em.css('border-bottom','1px solid red');
    em.parent().append('<p class="err-msg">Please enter valid e-mail.</p>');
    x = false;
  } else {
    em.css('border-bottom','1px solid inherit');
    em.parent().find('.err-msg').remove();
  }  

  if(ps.val().trim() == ''){
    ps.css('border-bottom','1px solid red');
    ps.parent().append('<p class="err-msg">Please enter password.</p>');
    x = false;
  } else {
    ps.css('border-bottom','1px solid inherit');
    ps.parent().find('.err-msg').remove();
  }
  if(x==false) {
    return false;
  }

});

// Other JS
$(document).ready(function(){
   if(window.location.toString().includes("blogs/news/")) // This doesn't work, any suggestions?
    {
      // $(".shg-box.blog-section-main").hide();
    size_li = $(".shg-box.blog-section-main").size();
      //$('<div id="loadMore">LoadMore</div>').insertAfter('blog-section-main:lt(6)');
        //$('<div id="loadMore">LoadMore</div>').insertAfter('.shg-box.blog-section-main:lt(6)');
      //$('<div id="loadMore">LoadMore</div>').insertAfter('.shg-box.blog-section-main:lt(6)');
    var x=6;
       setTimeout( function(){
      //$(".shg-box.blog-section-main").show(); 
        //$(".shg-box.blog-section-main:first").show();
        //$('.shg-box.blog-section-main').eq(3).show();
       size_li = $(".shg-box.blog-section-main").size();
         $('.shg-box.blog-section-main:lt(6)').show();
            $('.shg-box.blog-section-main:lt('+x+')').show();
            $('#loadMore').click(function () {
                x= (x+5 <= size_li) ? x+5 : size_li;
                $('.shg-box.blog-section-main:lt('+x+')').show();
            });
         },2000);
    }
});

var triggereds = false;

function ScrollExecute() {
  // Locate loadmore button
  var moreButon = $('#moreprod').last();
  //console.log(moreButon);
  // Get URL from the loadmore button
  var nextUrl = $(moreButon).find('a').attr("data-more");
  $('#moreprod').click(function(){
    
  // Button position when AJAX call should be made one time
  if ((($(moreButon).offset().top - $(window).scrollTop()) < 800) && (triggereds == false)) {
  
    triggereds = true;
	
    // Make ajax call to next page for load more data
    
    $.ajax({
      url: nextUrl,
      type: 'GET',
      beforeSend: function() {
        moreButon.remove();
        $(".loaderprod").show();
      }
    })
    .done(function(data) {
      // Append data
      $(".loaderprod").hide();
      $('.blog-product-view').append($(data).find('.blog-product-view').html());
      // On success, reset shortcircuit
      triggereds = false
      
    });
  }
  });
}

$(document).ready(function () {
  $(window).scroll(function(){
    ScrollExecute();
  });
});


var trig = false;

function ScrollExecuteMen() {
  // Locate loadmore button
  var moreButon = $('#moremen').last();
  //console.log(moreButon);
  // Get URL from the loadmore button
  var nextUrl = $(moreButon).find('a').attr("data-more");
  $('#moremen').click(function(){
    
  // Button position when AJAX call should be made one time
  if ((($(moreButon).offset().top - $(window).scrollTop()) < 800) && (trig == false)) {
  
    trig = true;
	
    // Make ajax call to next page for load more data
    
    $.ajax({
      url: nextUrl,
      type: 'GET',
      beforeSend: function() {
        moreButon.remove();
        $(".loadermen").show();
      }
    })
    .done(function(data) {
      // Append data
      $(".loadermen").hide();
      $('.blog-list-men').append($(data).find('.blog-list-men').html());
      // On success, reset shortcircuit
      trig = false
      
    });
  }
  });
}

$(document).ready(function () {
  $(window).scroll(function(){
    ScrollExecuteMen();
  });
});

function toggleDropdown($elem, $content) {
    if ($($elem).hasClass("highlight")){
      $($elem).removeClass("highlight");
    } else {
      $($elem).addClass("highlight");
    }
    $($content).slideToggle();

}
$(document).ready(function(){
  // Initialise first row of dropdown list
  $('.every-first').addClass("highlight");
  $(".why-dropdown-content.first-con").show();
  $(".fifth-con").css({"border-bottom": "1px solid rgba(151, 151, 151, 0.5)"});

  const $dropdownList = $('.shg-box-content').find(".why-dropdown-list");
  $(".why-dropdown-content.sec-con").hide();
  $(".why-dropdown-content.third-con").hide();
  $(".why-dropdown-content.fourth-con").hide();
  $(".why-dropdown-content.fifth-con").hide();
  $(".why-dropdown-content.sixth-con").hide();

  $($dropdownList).each(function() {
    if ($(this).find(".nursing-fifth").length > 0) {
      $(this).addClass("why-dropdown-last-border");
    }
    $(this).on('click', function() {
      if ($(this).find(".every-first").length > 0) {
        toggleDropdown($(".every-first"), $(".why-dropdown-content.first-con"));
      } else if ($(this).find(".extra-second").length > 0) {
        toggleDropdown($(".extra-second"), $(".why-dropdown-content.sec-con"));
      } else if ($(this).find(".every-third").length > 0) {
        toggleDropdown($(".every-third"), $(".why-dropdown-content.third-con"));
      } else if ($(this).find(".extra-forth").length > 0) {
        toggleDropdown($(".extra-forth"), $(".why-dropdown-content.fourth-con"));
      } else if ($(this).find(".high-cut").length > 0) {
        toggleDropdown($(".high-cut"), $(".why-dropdown-content.fifth-con"));
      } else if ($(this).find(".nursing-fifth").length > 0) {
        $(this).toggleClass("why-dropdown-last-border");
        toggleDropdown($(".nursing-fifth"), $(".why-dropdown-content.sixth-con"));
      } 
    });
  });
}); 

$(document).ready(function(){
	$("#shopify-section-hc-custom-product-recommendations").appendTo(".shg-c.prod_tab_content");
});

function TextBox_AddToIntValue(targetId,addToValue)
{
    var input = document.getElementById(targetId);
    var textInt = parseInt(input.value);
    if(isNaN(textInt))
    {
        textInt = 0;
    }
    if (textInt + addToValue < 1) {
      input.value = 1;
    } else {
      input.value = textInt + addToValue;
    }
}

$(document).ready(function(){
  $('.size-chart-open-popup').click(function(){
    var button = $('.shg-c.custome_tab').clone();
    if($(".package .shg-c.custome_tab ").length == 0) {
    	$('.package').html(button);
    }     
  });  
}); 
/*dropdown change script start*/
var x, i, j, selElmnt, a, b, c;
/*look for any elements with the class "custom-select":*/
x = document.getElementsByClassName("custom_dropdown_selector");
for (i = 0; i < x.length; i++) {
  selElmnt = x[i].getElementsByTagName("select")[0];
  /*for each element, create a new DIV that will act as the selected item:*/
  a = document.createElement("DIV");
  a.setAttribute("class", "select-selected");
  if (theme.strings.plusPickAnOptionSelect && !selElmnt.dataset.plusSelectedVariant && selElmnt.options.length > 1) {
    var selLabel = $('label[for="' + selElmnt.id + '"]').html().trim();
    a.innerHTML = theme.strings.plusPickAnOptionSelect.replace("{{ option }}", selLabel); 
  } else {
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
  }
  x[i].appendChild(a);
  /*for each element, create a new DIV that will contain the option list:*/
  b = document.createElement("DIV");
  b.setAttribute("class", "select-items select-hide");
  for (j = 0; j < selElmnt.length; j++) {
    /*for each option in the original select element,
    create a new DIV that will act as an option item:*/
    c = document.createElement("DIV");
    c.innerHTML = selElmnt.options[j].innerHTML;
    c.addEventListener("click", function(e) {
        /*when an item is clicked, update the original select box,
        and the selected item:*/
        var y, i, k, s, h;
        s = this.parentNode.parentNode.getElementsByTagName("select")[0];
        h = this.parentNode.previousSibling;
        var z = document.getElementsByClassName("product-single__title")[0];
        for (i = 0; i < s.length; i++) {
          if (s.options[i].innerHTML == this.innerHTML) {
            s.selectedIndex = i;
            var event = new Event('change');            
            // Dispatch it.
            s.dispatchEvent(event);
            h.innerHTML = this.innerHTML;
            //z.innerHTML = this.innerHTML;
            y = this.parentNode.getElementsByClassName("same-as-selected");
            for (k = 0; k < y.length; k++) {
              y[k].removeAttribute("class");
            }
            this.setAttribute("class", "same-as-selected");
            break;
          }
        }
        h.click();
    });
    b.appendChild(c);
  }
  x[i].appendChild(b);
  a.addEventListener("click", function(e) {
      /*when the select box is clicked, close any other select boxes,
      and open/close the current select box:*/
      e.stopPropagation();
      closeAllSelect(this);
      this.nextSibling.classList.toggle("select-hide");
      this.classList.toggle("select-arrow-active");
    });
}
function closeAllSelect(elmnt) {
  /*a function that will close all select boxes in the document,
  except the current select box:*/
  var x, y, i, arrNo = [];
  x = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");
  for (i = 0; i < y.length; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i)
    } else {
      y[i].classList.remove("select-arrow-active");
    }
  }
  for (i = 0; i < x.length; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add("select-hide");
    }
  }
}
/*if the user clicks anywhere outside the select box,
then close all select boxes:*/
document.addEventListener("click", closeAllSelect);
/*dropdown change script end*/


//click on Forgot

/*14-10-2019 start*/
$(function () {
  	$('#drop-show-top-link').on('change', function() {
      var val = $(this).val();
      var offset = 100;
      $("html, body").animate({ scrollTop: $('#'+val).offset().top - offset }, 1000)
    });
  
});
/*14-10-2019 end*/

//terms and privacy
$(".terms-privacy #s-09cadb58-89af-4672-81e2-33b589ff7b7e").css("display", "none");
$(".terms-privacy #s-aa5c1faa-cf92-4cc6-a059-4811bfe2e530").css("display", "none");
$(".terms-privacy #s-798c1a7a-6010-4d20-8e9d-007d93434b30").css("display", "none");
$(".terms-privacy #s-27fdd94f-6cda-47aa-b986-0c47c1204cbd").css("display", "none");

$("#s-5727bc8e-f96f-4105-9030-be4ec134dd1b").click(function(){
  $(".terms-privacy #s-09cadb58-89af-4672-81e2-33b589ff7b7e").show();
  $(".terms-privacy #s-aa5c1faa-cf92-4cc6-a059-4811bfe2e530").show();
  $(".terms-privacy #s-798c1a7a-6010-4d20-8e9d-007d93434b30").show();
  $(".terms-privacy #s-27fdd94f-6cda-47aa-b986-0c47c1204cbd").show();
  $(this).hide();
});

$(window).scroll(function() {
jQuery('.product-single__photo-wrapper').each(function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    var parItem = $(this).children().attr('data-image-id');
    if((elementBottom > viewportTop) && (elementTop < viewportBottom))
    	jQuery('.product-single__thumbnails-item').each(function() {
    	var item_id = $(this).children().attr('data-thumbnail-id');
    	if(item_id == parItem){
    		$(this).children().attr('aria-current','true');
    		$(this).children().addClass('active-thumb');
    	}else{
    		$(this).children().removeAttr('aria-current');
    		$(this).children().removeClass('active-thumb');
    	}

    	});
});
});
function myFunction(item) {
  //jQuery('.product-single__thumbnails-item').each(function() {
    	//var item_id = $(this).children().attr('data-thumbnail-id');
    	//if(item_id == item){
    		$("html, body").animate({ scrollTop: $('#FeaturedImageZoom-product-template-'+item+'-wrapper').offset().top }, 1000);
    	//}
    //});
}
$('body').on('click', '.product-single__thumbnail', function(e) {
  e.preventDefault();
  goToSlide($(this));
});
function goToSlide(el) {
  // Get the index number of parent <li> tag so we can navigate to slide with same index.
  let index = $(el).closest('.js_item').index();
  
  $('.mobile-image .qv_main').slick('slickGoTo', index);
}

function dynamicThumbnails(){
  var $thumbWrapper = $('.template-product').find('.thumbnails-wrapper');
  var $thumbnails = $($thumbWrapper).find('li');
  var numThumbnails = $($thumbnails).length;
  var value = 80 - (10 * numThumbnails);
  if (numThumbnails < 8) {
    $($thumbWrapper).css({"top": value.toString() + "vh"});
  } else {
    $($thumbWrapper).css({"top": "10vh"});
  }
}

function dynamicRowHeightSetter(template, elemToFind){
  var $reccoList = $(template).find(elemToFind);
  var maxHeight = 0;

  //reset height before resize
  $($reccoList).each(function() {
    $(this).css('height','max-content');
  });

  //find max height of entire row
  $($reccoList).each(function() {
    if ($(this).height() > maxHeight) {
      maxHeight = $(this).height();
    }
  });

  //set max height of entire row
  $($reccoList).each(function() {
    if (maxHeight > 0) {
      $(this).css({"height": maxHeight.toString() + "px"});
    }
  });
  return maxHeight
}

$(document).ready(function(){
  $('.mobile-nav--open').click(function(){
  	$('.account-popup').hide();
    $('.has-item.open_drawer').hide();
  });

  dynamicThumbnails(); //for thumbnails layout on product page
  dynamicRowHeightSetter(".template-product", ".product-card__title"); //for recommended products section
  dynamicRowHeightSetter(".template-page", ".product-card .prd-desc"); //shop men/shop women
  dynamicRowHeightSetter(".template-article .blog-product-main", ".pr-name"); //blog page
  dynamicRowHeightSetter(".template-article .blog-product-main", ".product-desc"); //blog page
  dynamicRowHeightSetter(".tested-sec", ".fsdr-desc h2"); //testimonial sliders
  dynamicRowHeightSetter(".tested-sec", ".ssdr-desc h2"); //testimonial sliders
  dynamicRowHeightSetter(".mh-tested-sec", ".shg-sld h2"); //testimonial sliders
  dynamicRowHeightSetter(".mh-tested-sec", ".ssdr-desc h2"); //testimonial sliders
  dynamicRowHeightSetter(".mh-tested-sec", ".fsdr-desc h2"); //testimonial sliders
  
  
  resetHeightOnMobile();

});  

var counting = 0;
var counting1 = 0;
$(document).ready(function() {
  $(document).on('swipeleft swiperight', '.template-page:not(.mens-health) .mens-top-sec', function(event) {
    event.stopPropagation();
    event.preventDefault();
   });
  // Remove fade animation for tier one and two banners
  const $sliderItems = $('.template-page:not(.mens-health)').find('.mens-top-sec').find('.shg-sld-item').find('.shg-sld-fade');
  $sliderItems.css({
    "-webkit-animation-name": "none",
    "animation-name": "none"
  });

  const $sliderDotsContainer = $('.template-page:not(.mens-health)').find('.shg-sld-dots').first();
  var currentIndex = 0;
  var count = 0;

  // Get index of current active slide/dot
  $sliderDotsContainer.children().each(function() {
    if ($(this).hasClass('shg-sld-active')) {
      currentIndex = count;
      return currentIndex;
    }
    count++;
  });

  // Bind click function to dots (for changing slides)
  $sliderDotsContainer.find('.shg-sld-dot').each(function() {
    $(this).on('click', function(e) {
      var index = 0;
      var count = 0;

      $sliderDotsContainer.find('.shg-sld-dot').removeClass('shg-sld-active');
      $(this).addClass('shg-sld-active');

      // Get index of slide/dot clicked
      $sliderDotsContainer.children().each(function() {
        if ($(this).hasClass('shg-sld-active')) {
          index = count;
        }
        count++;
      });

      if (index != currentIndex) {
        // Tier one banner animation
        var count = 0;
        $tierOneSlidesContainer = $('.template-page:not(.mens-health)')
        .find('.mens-top-sec')
        .find('.shg-sld-slides')
        .first()
        .find('.shogun-image-container');

        $tierOneSlidesContainer.each(function() {
          if (count == index) { 
            $(this).css({
              "left": "-100vw"
            })
            $(this).animate({
              left: "0"
            }, 500);
          }
          count++;
        });

        // Tier two banner animation
        var count = 0;
        $tierTwoSlidesContainer = $('.template-page:not(.mens-health)')
        .find('.mens-top-sec')
        .find('.shg-sld-slides')
        .eq(1)
        .find('.tier-two-banner');

        $tierTwoSlidesContainer.each(function() {
          if (count == index) { 
            $(this).css({
              "right": "-100vw"
            })
            $(this).animate({
              right: "0"
            }, 500);
          }
          count++;
        });
      }

      // Bind tier two banner dots to tier one banner dots
      const $sliderTierTwoDotsContainer = $('.template-page:not(.mens-health)').find('.shg-sld-dots').eq(1).find('.shg-sld-dot');
      $sliderTierTwoDotsContainer.removeClass('shg-sld-active');
      const $sliderTierTwoActiveDot = $($sliderTierTwoDotsContainer[index]);
      $sliderTierTwoActiveDot.addClass('shg-sld-active');

      // Bind tier two banner change to tier one banner change
      const $sliderBannerContainer = $('.template-page:not(.mens-health)').find('.shg-sld').eq(1).find('.shg-sld-item');
      $sliderBannerContainer.removeClass('shg-sld-active');
      const $activeTierTwoBanner = $($sliderBannerContainer[index]);
      $activeTierTwoBanner.addClass('shg-sld-active');

      currentIndex = index;
      counter = currentIndex;
      clearInterval(slideshowInterval);
      slideshowInterval = setInterval(function() {
        if (counter < 2) {    
          counter += 1;  
        } else {
          counter = 0;
        }
        $sliderDotsContainer.find('.shg-sld-dot').eq(counter).trigger('click');
      }, 5000);
    });
  });

  var counter = currentIndex;
  var slideshowInterval = setInterval(function() {
    if (counter < 2) {    
      counter += 1;  
    } else {
      counter = 0;
    }
    $sliderDotsContainer.find('.shg-sld-dot').eq(counter).trigger('click');
  }, 5000);

  $(".template-page:not(.mens-health)").find(".mh-men-range").closest(".shg-box-content").find(".shg-product").css({"height": "100%"});
  
  var counting = 0;
  var counting1 = 0;
  if ($(".template-page:not(.mens-health) .mh-men-range").length > 0) {
    var interval = setInterval(function() {
      if (counting <= 0) { 
        counting = dynamicRowHeightSetter(".template-page", ".shg-product-title-component");       
      } else {
        clearInterval(interval);
      }
    }, 100);
    var interval1 = setInterval(function() {
      if (counting1 <= 0) {
        counting1 = dynamicRowHeightSetter(".template-page", ".mh-cat-short-desc .shogun-heading-component");
      } else {
        clearInterval(interval1);
      }
    }, 100);
  }
});

$(window).resize(
  $.debounce(50, function() {
    dynamicRowHeightSetter(".template-product", ".product-card__title"); //for recommended products section
    dynamicRowHeightSetter(".template-page", ".product-card .prd-desc"); //shop men/shop women
    dynamicRowHeightSetter(".template-page", ".shg-product-title-component"); //shop men/shop women
    dynamicRowHeightSetter(".template-page", ".mh-cat-short-desc .shogun-heading-component"); //shop men/shop women
    dynamicRowHeightSetter(".template-article .blog-product-main", ".pr-name"); //blog page
    dynamicRowHeightSetter(".template-article .blog-product-main", ".product-desc"); //blog page
    dynamicRowHeightSetter(".tested-sec", ".fsdr-desc h2"); //testimonial sliders
    dynamicRowHeightSetter(".tested-sec", ".ssdr-desc h2"); //testimonial sliders
    dynamicRowHeightSetter(".mh-tested-sec", ".shg-sld h2"); //testimonial sliders
    dynamicRowHeightSetter(".mh-tested-sec", ".ssdr-desc h2"); //testimonial sliders
    dynamicRowHeightSetter(".mh-tested-sec", ".fsdr-desc h2"); //testimonial sliders
    
    resetHeightOnMobile();
  })
);
$('.template-blog #moremore').click(function(){
  if($(window).width() > 480) {
    setTimeout( function(){
      setDynamicHeightPerRow(".template-blog .blog-list-view li", ".article__title", 2);
      setDynamicHeightPerRow(".template-blog .blog-list-view li", ".blog-desc", 2);
    }, 1500);
  }
});

if($(window).width() > 480) {
  setDynamicHeightPerRow(".template-blog .blog-list-view li", ".article__title", 2);
  setDynamicHeightPerRow(".template-blog .blog-list-view li", ".blog-desc", 2);
}

function setDynamicHeightPerRow(list, item, itemsPerRow) {
  for(var itemIndex=0; itemIndex < $(item).length; itemIndex+=itemsPerRow) {
    var higherHeight = 0;
    var itemInd = itemIndex;
    var $firstItem = $(list).eq(itemInd).find(item);
    var $secondItem = $(list).eq(++itemInd).find(item);

    if($firstItem.height() > $secondItem.height()) {
      higherHeight = $firstItem.height();
    } else {
      higherHeight = $secondItem.height();
    }
    
    $firstItem.height(higherHeight);
    $secondItem.height(higherHeight);
  }
}

function findTabToOpen($this) {
  var tab = $this.data('tab') ? $this.data('tab').toUpperCase().trim() : 'DELIVERY';
  var tabIndex, deliveryTabIndex;

  $('.prod_tab_content .shogun-tabs .shogun-tab-title:visible').each(function() {
    var currentTabTitle = $(this).text().toUpperCase().trim();
    if(currentTabTitle == tab) {
      tabIndex = $(this).closest('.shogun-tab').index();
    } else if(currentTabTitle == 'DELIVERY') {
      deliveryTabIndex = $(this).closest('.shogun-tab').index();
    }
  });
  if($(window).width() < 1024) {
    if(tabIndex >= 0) {
      return tabIndex/2;
    } else if (deliveryTabIndex >= 0) {
      //If product.metafields.sizing_help.tab_to_open is not present, return delivery tab's index
      return deliveryTabIndex/2;
    } else {
      //Size guide tab index
      return 1;
    }
  } else {
    if(tabIndex >= 0) {
      return tabIndex;
    } else if (deliveryTabIndex >= 0) {
      //If product.metafields.sizing_help.tab_to_open is not present, return delivery tab's index
      return deliveryTabIndex;
    } else {
      //Size guide tab index
      return 1;
    }
  }
}

function resetHeight(template, elemToFind){
  var $reccoList = $(template).find(elemToFind);

  $($reccoList).each(function() {
    $(this).css('height','max-content');
  });
}
function resetHeightOnMobile() {
  //for mobile

  if($(window).width() < 478) {
    resetHeight(".template-page", ".product-card .prd-desc"); //shop men/shop women
    resetHeight(".why-us-section .why-sect", ".shogun-image-container"); //why us section of home, mums' zone, men's health
    resetHeight(".template-blog .blog-list-view", ".blog-desc"); //blog men/blog women
    resetHeight(".template-blog .blog-list-view", ".article__title"); //blog men/blog women
    resetHeight(".template-blog .blog-list-view", ".article__title"); //blog men/blog women
  }
}

// $(window).on("load", function() {
//   // if (document.readyState == "complete") {
//     var interval = setInterval(function() {
//       if (counting1 < 5) {
//         dynamicRowHeightSetter(".template-page", ".shg-product-title-component");
//         dynamicRowHeightSetter(".template-page", ".mh-cat-short-desc .shogun-heading-component");

//         counting1++;
//       }
//       if (counting1 >= 5) {
//         clearInterval(interval);
//       }
//       console.log(counting1);
//     }, 500);
//   // }
// });

/* Womens New Mum tier one and two banners */
$(document).ready(function() {
  // Remove fade animation for tier one and two banners
  const $sliderItems = $('.template-page:not(.mens-health)').find('.mens-top-sdr').find('.shg-sld-item').find('.shg-sld-fade');
  $sliderItems.css({ 
    "-webkit-animation-name": "none",
    "animation-name": "none"
  });

  const $sliderItemsTwo = $('.template-page:not(.mens-health)').find('.mens-top-main-sec').find('.shg-sld-item').find('.shg-sld-fade');
  $sliderItemsTwo.css({
    "-webkit-animation-name": "none",
    "animation-name": "none"
  });

  const $sliderDotsContainer = $('.template-page').find('.shg-sld-dots').first();
  var currentIndex = 0;
  var count = 0;

  // Get index of current active slide/dot
  $sliderDotsContainer.children().each(function() {
    if ($(this).hasClass('shg-sld-active')) {
      currentIndex = count;
      return currentIndex;
    }
    count++;
  });

  // Bind click function to dots (for changing slides)
  $sliderDotsContainer.find('.shg-sld-dot').each(function() {
    $(this).on('click', function(e) {
      var index = 0;
      var count = 0;

      $sliderDotsContainer.find('.shg-sld-dot').removeClass('shg-sld-active');
      $(this).addClass('shg-sld-active');

      // Get index of slide/dot clicked
      $sliderDotsContainer.children().each(function() {
        if ($(this).hasClass('shg-sld-active')) {
          index = count;
        }
        count++;
      });

      if (index != currentIndex) {
        // Tier one banner animation
        var count = 0;
        $tierOneSlidesContainer = $('.template-page:not(.mens-health)')
        .find('.mens-top-sdr')
        .find('.shg-sld-slides')
        .find('.shg-sld-item');

        $tierOneSlidesContainer.each(function() {
          if (count == index) { 
            $(this).css({
              "position": "relative",
              "left": "-100vw"
            })
            $(this).animate({
              left: "0"
            }, 500);
          }
          count++;
        });

        // Tier two banner animation
        var count = 0;
        $tierTwoSlidesContainer = $('.template-page:not(.mens-health)')
        .find('.mens-top-main-sec')
        .find('.shg-sld-slides')
        .find('.shg-sld-item');

        $tierTwoSlidesContainer.each(function() {
          if (count == index) { 
            $(this).css({
              "position": "relative",
              "right": "-100vw"
            })
            $(this).animate({
              right: "0"
            }, 500);
          }
          count++;
        });
      }

      // Bind tier two banner dots to tier one banner dots
      const $sliderTierTwoDotsContainer = $('.template-page:not(.mens-health)').find('.shg-sld-dots').eq(1).find('.shg-sld-dot');
      $sliderTierTwoDotsContainer.removeClass('shg-sld-active');
      const $sliderTierTwoActiveDot = $($sliderTierTwoDotsContainer[index]);
      $sliderTierTwoActiveDot.addClass('shg-sld-active');

      // Bind tier two banner change to tier one banner change
      const $sliderBannerContainer = $('.template-page:not(.mens-health)').find('.shg-sld').eq(1).find('.shg-sld-item');
      $sliderBannerContainer.removeClass('shg-sld-active');
      const $activeTierTwoBanner = $($sliderBannerContainer[index]);
      $activeTierTwoBanner.addClass('shg-sld-active');

      currentIndex = index;
      counter = currentIndex;
      clearInterval(slideshowInterval);
      slideshowInterval = setInterval(function() {
        if (counter < 2) {    
          counter += 1;  
        } else {
          counter = 0;
        }
        $sliderDotsContainer.find('.shg-sld-dot').eq(counter).trigger('click');
      }, 5000);
    });
  });

  var counter = currentIndex;
  var slideshowInterval = setInterval(function() {
    if (counter < 2) {    
      counter += 1;  
    } else {
      counter = 0;
    }
    $sliderDotsContainer.find('.shg-sld-dot').eq(counter).trigger('click');
  }, 5000);

  //Product page remove variants
  // if ($('body').hasClass('shop-men') || $('body').hasClass('shop-women')) {
    $(document).on('click','.shg-product-image-wrapper, .product-card__image-with-placeholder-wrapper',function(e){
      e.preventDefault();
      var $shopBtn = $(this).closest('.shg-product').find('.shop-now-button a')[0];
      if(!$shopBtn) {
        $shopBtn = $(this).closest('.product-card').find('a')[0];
      }
      if($shopBtn) {
        $shopBtn.click();
      }
    });
  // }

  $(window).resize(
    $.debounce(50, function() {
      if($(window).width() > 1024) {
        //Set width of top nav triangle layout - for compatibility on Edge browser
        var triangleWidth = $('.site-header .top-triangle .arrow').outerWidth();
        var triangleAfter = ($('.site-header .top-triangle').outerWidth() - triangleWidth) / 2;
        var parentWidth = $('.site-header.border-bottom').outerWidth();
        var navWidth = parentWidth - triangleAfter - triangleWidth;
        var percentage = (navWidth / parentWidth) * 100;
        $('.nav-background').width(percentage+'%');
      } else {
        $('.nav-background').width('100%');
      }
    })
  );
  
  //Adjust autoscroll when nav link is clicked or link has hash, WHY US and HELP page
  console.log('confitex-two.js loaded!'); 
  if ($('body').hasClass('why-us') || $('body').hasClass('help') || $('body').hasClass('terms-and-conditions')) {

    if (location.hash) {
      $('html').scrollTop(0);
      scrollToTarget(location.hash, 'down');
    }

    //Modify all links with autoscroll
    $(".desktop-menu a, .mobile-nav__sublist-link").each(function() {
      var parentLink = window.location.pathname;
      parentLink = parentLink.split('/').pop();

      var link = $(this).attr('href');
      if(link && link.indexOf('#') >= 0 && link.indexOf(parentLink+'?') >= 0) {
        var target = link.substr(link.indexOf('#'));
        $(this)
          .css('pointer-events','none')
          .closest('li')
          .addClass('scroll-links')
          .attr('data-scroll-to',target);
      }
    });

    //Modify link index with autoscroll
    $(".multi-link-line a").each(function() {
      debugger;
      var parentLink = window.location.pathname;
      parentLink = parentLink.split('/').pop();

      var link = $(this).attr('href');

      if(link) {
        $(this)
          .attr('href','#')
          .addClass('scroll-links')
          .attr('data-scroll-to',link);
      }
    });

    $(document).on('click','.scroll-links',function(e){
      var target = $(this).attr('data-scroll-to');
      if(target) {
        var distance = $('html').scrollTop() - $(target).offset().top;
        var direction = distance > 0 ? 'up' : 'down';

        if($(window).width() <= 1024) {
          $('.mobile-nav--close').trigger('click');
        }
        scrollToTarget(target, direction);
      }
    });

    //Link list mobile
    $('body').on('change', '#why-us-select select.browser-default', function() {
      var selectedTab = $(this).children("option:selected").val();
      scrollToTarget(selectedTab, 'down');
    });
  }

  var nLoop = 0;

  function scrollToTarget(target, direction) {
    var targetOffset = $(target).offset().top - 50;

    if($('body').hasClass('safari')) {
      //percentage error on safari scroll is observed on some pages, we need to manually adjust it
      if($('body').hasClass('why-us') || $('body').hasClass('help') || $('body').hasClass('terms-and-conditions')) {
        if($(window).width() > 1599) {
          var percentage = targetOffset * 0.10; // +10%
          targetOffset = targetOffset + percentage;
        } else if($(window).width() > 1024) {
          var percentage = targetOffset * 0.12; // -12%
          targetOffset = targetOffset - percentage;
        }
      }
    }
    
    if (target) {
      if(nLoop > 0) {
        //smaller IOS devices uses $(body) while, chrome, safari and other browsers use $(html)
        ///use of $(html,body) causes scroll error, need to use 1 only
        var $docu = $('html').scrollTop() ? $('html') : $('body');
      } else {
        var $docu = $('html');
      }
      nLoop++;

      if(direction == 'up') {
        var offset = -60; //speed
        var targetLoc = $docu.scrollTop() > targetOffset - 100; //target location
      } else {
        var offset = 60;
        var targetLoc = $docu.scrollTop() < targetOffset - 120;
      }

      var scrollLimitDown = document.documentElement.offsetHeight - $(window).height();
      var nextScrollLeap = $docu.scrollTop() + offset;

      //Continuous scrolling until near the target element / page scroll limit
      if (targetLoc && nextScrollLeap < scrollLimitDown) {
        $docu.animate({
            scrollTop: nextScrollLeap
        }, 1, 'swing', function() {
          scrollToTarget(target, direction);            
        });
      } else {
        nLoop = 0;
      }
    }
  }
});
  
// NEOBADGER ADDITION 
  
window.addEventListener("load", function () {
  
  console.log('NEO PATCH ACTIVE', 2.2);
 
  // Patch for slick slider on Safari where there is a height calc issue. 
  var slide = document.querySelectorAll(".mobile-image .qv_main .slick-slide");
  slide.forEach(function (slide) {
    if (
      !!slide.querySelector("#slide-video") &&
      parseInt(getComputedStyle(slide).margin) > 1
    ) {
      slide.style.margin = "0px";
    }
  });
});
